import { Attributes, Misc, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';

export default class InvestorContact extends TemporalEntity {

    constructor() {
        super();
        this.makeObservable();
    }

    public investorContactId: number = 0;

    public investorId: number = 0;

    @Rules.Required()
    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    public contactId: number | null = null;

    @Attributes.NoTracking(Misc.SerialiseType.FullOnly)
    public contactName: string | null = null;

    @Rules.Required()
    public contactTypeId: number | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.contactName) {
            return "New investor contact";
        } else {
            return this.contactName;
        }
    }
}